import { Icon, type IconProps } from "@/components/ui/icon";

export function HdtSamplingIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="13" cy="10" r="3" fill="currentColor" />
      <circle cx="12.5" cy="20.5" r="1.5" fill="currentColor" />
      <circle cx="18.5" cy="4.5" r="1.5" fill="currentColor" />
      <circle cx="20" cy="12" r="1" fill="currentColor" />
      <circle cx="4" cy="22" r="1" fill="currentColor" />
      <circle cx="6" cy="16" r="2" fill="currentColor" />
      <circle cx="21" cy="21" r="1" fill="currentColor" />
      <circle cx="4.5" cy="3.5" r="1.5" fill="currentColor" />
    </Icon>
  );
}